import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Dataset, format, IModel, Metamodel } from 'shell-models-lib';
import { KafkaLinkedService } from '../linkedservice/kafka.linkedservice';

@Metamodel.model({
    name: adfModelTypeMap.kafka.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Kafka_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Kafka_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: KafkaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class KafkaDataset extends Dataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
